import React from 'react';
import PropTypes from 'prop-types';
import "./AlertCloseButton.css";
import { SVGIcon } from '@homeaway/react-svg';
import { CLOSE__16 } from '@homeaway/svg-defs';

function AlertCloseButton(props) {
  return React.createElement("button", {
    type: "button",
    className: "Alert__close",
    onClick: props.onClick
  }, React.createElement("span", {
    className: "Alert__close-flex"
  }, React.createElement(SVGIcon, {
    inlineFlex: true,
    markup: CLOSE__16
  }), React.createElement("span", {
    className: "sr-only"
  }, props.closeText)));
}

AlertCloseButton.propTypes = {
  closeText: PropTypes.string,
  onClick: PropTypes.func
};
export default AlertCloseButton;
//# sourceMappingURL=AlertCloseButton.js.map